import React from 'react';
import {
  Box, Container, Typography, Grid, Button,
} from '@mui/material';
import StyledBox from 'views/information-module/common/components/UI/FranchiseHeader/FranchiseHeader.styles';
import { ImgBox } from 'views/common/components';
import Typography500 from 'views/common/components/UI/Typography500';
import { useTranslation } from 'next-i18next';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';

const image = {
  src: '/imgs/franchise/franchiseHeader.jpg',
  alt: 'Franchise Opportunities',
};
const FranchiseHeader = () => {
  const { t } = useTranslation('fe_er_common_franchise_header');

  return (
    <StyledBox>
      <Container maxWidth="xl">
        <Box className="FHcontent">
          <Typography500 variant="h1" component="h1">
            {t('fe_er_common_franchise_header:eaglerider')}
            {' '}
            {t('fe_er_common_franchise_header:franchise_opportunities')}
          </Typography500>
          <Typography variant="body2" component="p" my={3}>
            {t('fe_er_common_franchise_header:fill_form')}
          </Typography>
          <Grid container spacing={2} className="FHBtnContainer">
            <Grid item>
              <Button
                href={PATHS.franchise.becomeFranchiseDoc()}
                component={NavigatorLink}
                target="_blank"
                variant="contained"
                color="primary"
                disableElevation>
                {t('fe_er_common_franchise_header:become_franchise')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="FHAboutBtn"
                href={PATHS.franchise.aboutUs()}
                component={NavigatorLink}
                color="primary"
                variant="outlined">
                {t('fe_er_common_franchise_header:why_eaglerider')}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Box className="MWCSImgContainer">
        <ImgBox image={image} imgHeight="100%" />
      </Box>
    </StyledBox>
  );
};

export { FranchiseHeader };
